















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class ContentVideo extends Vue {
	@Prop({ required: true })block!: any
	
	getEmbedLinkFromUrl(url: string): string | false {
		if (url.indexOf('youtube.com') !== -1 || url.indexOf('youtu.be') !== -1) {
			const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
			const match = url.match(regExp)

			if (match && match[2].length == 11) {
				return `<iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/${match[2]}" frameborder="0" allowfullscreen></iframe>`;
			} 
			
			return false
		} else if (url.indexOf('vimeo.com') !== -1) {
			const regExp = /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/
			const match = url.match(regExp)

			if (match && match[3].length > 0) {
				return `<iframe src="https://player.vimeo.com/video/${match[3]}" width="560" height="315" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>`;
			} 
			
			return false
		}

		return false
	}
}
